export enum ActivityAction {
  GO = "GO",
  UPDATE = "UPDATE",
  VIEW = "VIEW",
  MANAGE_PARTICIPANTS = "MANAGE_PARTICIPANTS",
  ASSIGN_MEETING_REP = "ASSIGN_MEETING_REP"
}
